import React from "react";
import { Box, InputAdornment } from "@mui/material";
import { Close } from "@mui/icons-material";
import { CustomTextInput } from "../TextInputs/style";
import { SELECT_COLOR } from "./selectConstants";

/**
 * Search row shared by all custom selector panels.
 */
export default function SelectSearchField({
  inputRef,
  id,
  value,
  onChange,
  onKeyDown,
  compact = false,
}) {
  return (
    <Box
      sx={{ p: 1, ...(compact ? { pt: 0.3 } : {}) }}
      onClick={(event) => event.stopPropagation()}
    >
      <CustomTextInput
        inputRef={inputRef}
        id={id}
        size="small"
        fullWidth
        autoComplete="off"
        spellCheck={false}
        label="Search"
        value={value}
        variant="standard"
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={onKeyDown}
        InputProps={{
          endAdornment: value ? (
            <InputAdornment position="end">
              <Close
                onMouseDown={(event) => event.stopPropagation()}
                onClick={(event) => {
                  event.stopPropagation();
                  onChange("");
                }}
                sx={{ cursor: "pointer", color: SELECT_COLOR }}
              />
            </InputAdornment>
          ) : undefined,
        }}
      />
    </Box>
  );
}
